import { Address } from '@amfam/policy/models';

import { Phone } from './phone';

export class Office {
  name: string;
  address: Address;
  phone: Phone;
}
